import { Injectable, autobind } from '@kaokei/use-vue-service';
import { DaoService } from './dao.service';

interface IGetAccount {
  contestId: string;
  mobile: string;
  verifyCode: string;
}

@Injectable()
export class LoginService {
  public visible = false;

  public goToEnvCheckDialogVisible = false;

  // 找回账号密码弹窗
  public getAccountVisible = false;
  public getAccountInfoVisible = false;

  public accountInfo = {
    account: '',
    pwd: '',
    username: '',
  };

  constructor(public daoService: DaoService) {}

  public loginByMobile(mobile: string, code: string) {
    return this.daoService.loginWithMobileCode(mobile, code);
  }

  public loginByAccount(account: string, password: string) {
    return this.daoService.loginWithAccountPassword(account, password);
  }

  public otherPlatformLoginByAccount(
    account: string,
    password: string,
    thirdPlatform: string
  ) {
    return this.daoService.otherPlatformLoginWithAccountPassword(
      account,
      password,
      thirdPlatform
    );
  }

  public queryGoToEnvCheckDialog() {
    this.daoService.queryGoToEnvCheck().then(res => {
      if (res.checkSign > 0) {
        this.showGoToEnvCheckDialog();
      }
    });
  }

  public getLoginAccount({ contestId, mobile, verifyCode }: IGetAccount) {
    return this.daoService.getUserAccountPassword({
      contestId,
      mobile,
      verifyCode,
    });
  }

  @autobind
  public showLoginDialog() {
    this.visible = true;
  }

  public hideLoginDialog() {
    this.visible = false;
  }

  public showGoToEnvCheckDialog() {
    this.goToEnvCheckDialogVisible = true;
  }

  public hideGoToEnvCheckDialog() {
    this.goToEnvCheckDialogVisible = false;
  }

  public toggleGetAccountVisible(visible: boolean) {
    this.getAccountVisible = visible;
  }

  public toggleAccountInfoVisible(visible: boolean) {
    this.getAccountInfoVisible = visible;
  }
}
